function checkEnabledFeatures(currentUser, feature) {
  if (
    currentUser &&
    currentUser.enabledFeatures &&
    currentUser.enabledFeatures.includes(feature)
  ) {
    return true;
  }
  return false;
}

export default checkEnabledFeatures;
